import {Button, Form, Modal, Spinner, InputGroup} from 'react-bootstrap'
import {FormattedMessage, useIntl, defineMessages, MessageDescriptor} from 'react-intl'
// import Select from 'react-select'
import {useEffect, useState} from 'react'
import {useMutation, useQuery} from '@apollo/client'
import {GET_NOTES_COMMISSION_DETAIL} from '../../../gql/queries/commissionReportsDetailsApiQueries'
import {ADD_NOTE_COMMISSION_DETAIL} from '../../../gql/mutations/commissionReportDetailMutations'

import {toast} from 'react-toastify'
import {ContentNotes} from './notes/ContentNotes'
import {IResNoteCommissionDetail} from '../../../types/commissionReportDetailApi'
import { NodeCommissionReportDetail } from '../../../types/commissionReportDetailApi'
import {parseId} from '../../../helpers'
import {MentionInput} from '../../../components/MentionInput'

interface IResAddNoteCommissionDetail {
  createCommissionReportNote: { success: boolean; errors?: { message: string }[] }
}

interface IModalProps {
  isOpen: boolean
  onClose: () => void
  infoEdit: NodeCommissionReportDetail | null
  refetch: () => void
}

const REASON_MESSAGES: Record<string, MessageDescriptor> = defineMessages({
  AMOUNT_PAID_INCORRECT: {id: 'commissions.detail.notes.reason.amountPaidIncorrect', defaultMessage: 'Amount paid is incorrect'},
  QUANTITY_MEMBERS_INCORRECT: {id: 'commissions.detail.notes.reason.quantityMembersIncorrect', defaultMessage: 'Quantity of members paid is incorrect'},
  EXPECTED_MORE_MONTHS: {id: 'commissions.detail.notes.reason.expectedMoreMonths', defaultMessage: 'I was expecting more months for this client'},
  NOT_PAID_FOR_CLIENT: {id: 'commissions.detail.notes.reason.notPaidForClient', defaultMessage: 'I was not paid for this client'},
  OTHER: {id: 'common.option.other', defaultMessage: 'Other'},
})

export const ModalNotesClaims: React.FC<IModalProps> =
({isOpen, 
  onClose,  
  infoEdit,
  refetch,}) => {
  const intl = useIntl()
  const space = ' '

  const {
    data: dataNotes,
    loading: loadingNotes,
    error: errorNotes,
    refetch: refetchNotes,
  } = useQuery<IResNoteCommissionDetail>(GET_NOTES_COMMISSION_DETAIL, {
    variables: { commissionReportDetailId: infoEdit != null ? parseId(infoEdit.id) : 0 },
    fetchPolicy: 'no-cache',
  })
  const [gqlAddNote, { loading, error }] = useMutation<IResAddNoteCommissionDetail>(ADD_NOTE_COMMISSION_DETAIL)

  const [value, setValue] = useState('')
  const [mentionedUserIds, setMentionedUserIds] = useState<string[]>([])
  const [isResolved, setIsResolved] = useState(false)
  const [noteType, setNoteType] = useState<'COMMENT' | 'CLAIM'>('CLAIM')
  const [claimReason, setClaimReason] = useState<string>('')

  // const [newStatus, setNewStatus] = useState('')

  useEffect(() => {
    if (error) toast.error(intl.formatMessage({id: 'common.error.withMessage', defaultMessage: 'Error: {message}'}, {message: error.message}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])
  useEffect(() => {
    if (errorNotes) toast.error(intl.formatMessage({id: 'common.error.withMessage', defaultMessage: 'Error: {message}'}, {message: errorNotes.message}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorNotes])


  const handleComment =  async () => {
    if (!value || infoEdit == null || !parseId(infoEdit.id)) return

    const variables = {
      input: {
        comments: value,
        commissionReportDetailId: parseId(infoEdit.id),
        noteType,
        claimReason: noteType === 'CLAIM' && claimReason ? claimReason : undefined,
        resolved: isResolved ? true : undefined,
        mentionedUserIds, // Array of user IDs that were mentioned with @
      }
    }

    const { data } = await gqlAddNote({ variables })
    if (data?.createCommissionReportNote?.success) {
      toast.success(intl.formatMessage({id: 'commissions.detail.notes.toast.added', defaultMessage: 'Note added successfully'}))
      setValue('')
      setMentionedUserIds([])
      setIsResolved(false)
      await refetchNotes() // <-- recarga la lista inmediatamente
    } else {
      toast.error(data?.createCommissionReportNote?.errors?.[0]?.message || intl.formatMessage({id: 'commissions.logs.error', defaultMessage: 'Error'}))
    }
  }

  return (
    <Modal show={isOpen} onHide={onClose} size='xl' 
      backdrop="static"
      keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title className='d-flex align-items-center gap-x-2'>
          <FormattedMessage id='commissions.detail.notes.title' defaultMessage='Record notes and claims' />{space}
          {loadingNotes || !dataNotes ? (
            <Spinner animation='border' size='sm' />
          ) : (
            intl.formatMessage({id: 'commissions.detail.notes.count', defaultMessage: '({count})'}, {count: dataNotes.commissionReportNotesByDetail.length})
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: '380px',
              maxHeight: '380px',
              overflowY: 'auto',
              backgroundColor: '#f8f8fa',
            }}
            className='px-3 py-2 border'
          >
            {loading || !dataNotes ? (
              <Spinner animation='border' />
            ) : (
              <ContentNotes notes={dataNotes?.commissionReportNotesByDetail ?? []} />                             
            )}
          </div>
          <div className='filters-header'>
            <InputGroup>

              <Form.Select
                value={noteType}
                onChange={(e) => {
                  setNoteType(e.target.value as 'COMMENT' | 'CLAIM')
                  if (e.target.value !== 'CLAIM') setClaimReason('')
                }}
                
              >
                <option value=''>{intl.formatMessage({id: 'commissions.detail.notes.selectType', defaultMessage: '-- Select a type --'})}</option>
                <option value='CLAIM'>{intl.formatMessage({id: 'commissions.detail.notes.typeClaim', defaultMessage: 'Claim'})}</option>
                <option value='COMMENT'>{intl.formatMessage({id: 'commissions.detail.notes.typeComment', defaultMessage: 'Comment'})}</option>
              </Form.Select>
              <Form.Select
                value={claimReason}
                onChange={(e) => setClaimReason(e.target.value)}
                disabled={noteType !== 'CLAIM'}
              >
                <option value=''>{intl.formatMessage({id: 'commissions.detail.notes.selectReason', defaultMessage: '-- Select a reason --'})}</option>
                {Object.entries(REASON_MESSAGES).map(([key, desc]) => (
                  <option key={key} value={key}>
                    {intl.formatMessage(desc)}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
              
          </div>
          <div className='mb-3 mt-4'>
            <MentionInput
              placeholder={intl.formatMessage({id: 'commissions.detail.notes.commentPlaceholder', defaultMessage: 'Type your comments here... Use @ to mention users'})}
              value={value}
              onChange={(newValue, mentionedIds) => {
                setValue(newValue)
                setMentionedUserIds(mentionedIds)
              }}
              minHeight='120px'
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className='justify-content-between'>
        <Form.Check
          checked={isResolved}
          onChange={(e) => {
            setIsResolved(e.target.checked)
          }}
          type={'checkbox'}
          id={`default-${'checkbox'}`}
          label={<span style={{color: 'black'}}><FormattedMessage id='commissions.detail.notes.markResolved' defaultMessage='Mark claim as resolved' /></span>}
        />
        <div className='d-flex align-items-center gap-1'>
          <Button
            variant='secondary'
            size='sm'
            onClick={() => {
              onClose()
              refetch() // <- este es el que viene del padre por props
            }}
          >
            <FormattedMessage id='common.action.close' defaultMessage='Close' />
          </Button>
          <Button size='sm'
            variant='info'
            onClick={handleComment}
            disabled={loading || !value || loadingNotes || (noteType === 'CLAIM' && !claimReason)}
          >
            <FormattedMessage id='commissions.logs.submit' defaultMessage='Submit' />
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
